import { render, staticRenderFns } from "./DepartmentPopup.vue?vue&type=template&id=b53b5da4&scoped=true"
import script from "./DepartmentPopup.vue?vue&type=script&lang=js"
export * from "./DepartmentPopup.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPopup.vue?vue&type=style&index=0&id=b53b5da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b5da4",
  null
  
)

export default component.exports